import { render, staticRenderFns } from "./SociosContacto.vue?vue&type=template&id=c906d7b0&"
import script from "./SociosContacto.vue?vue&type=script&lang=js&"
export * from "./SociosContacto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports